<div class="d-flex position-relative align-items-center justify-content-end w-100">
  <button type="button" [attr.aria-label]="'dialog.loadSetInsert.buttons.ignore' | translate" mat-icon-button class="position-absolute top-0" (click)="ignore()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="d-flex flex-column w-100 h-100 p-2">
  <h5>{{ 'dialog.loadSetInsert.title' | translate }}</h5>

  <div class="d-flex flex-column gap-2 mt-2">
    <div *ngFor="let draft of drafts"
         class="d-flex align-items-center justify-content-between border rounded p-2">
      <div class="d-flex flex-column">
        <span>{{ draft.brand || ('dialog.loadSetInsert.unknownBrand' | translate) }}</span>
        <small>
          {{ 'dialog.loadSetInsert.itemCount' | translate:{ count: draft.itemCount } }}
          <ng-container *ngIf="draft.savedAt"> · {{ draft.savedAt | appDate:'short' }}</ng-container>
        </small>
      </div>
      <div class="d-flex gap-2">
        <button type="button" mat-stroked-button (click)="preview(draft)" [disabled]="draft.itemCount === 0">
          {{ 'dialog.loadSetInsert.buttons.preview' | translate }}
        </button>
        <button type="button" mat-raised-button color="primary" (click)="restore(draft)">
          {{ 'dialog.loadSetInsert.buttons.restore' | translate }}
        </button>
        <button type="button" mat-raised-button color="warn" (click)="deleteDraft(draft)">
          {{ 'dialog.loadSetInsert.buttons.deleteLoad' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button type="button" mat-raised-button (click)="ignore()">
      {{ 'dialog.loadSetInsert.buttons.ignore' | translate }}
    </button>
  </div>
</div>
